<!-- remover comment -->
<template>
    <div id="idNav">
        <b-navbar toggleable="lg" type="dark" variant="info">
            <b-navbar-brand href="#/">
              <img v-if="logoUrl" :src="logoUrl" :alt="nomeEmpresa"/>
              <div v-else>{{nomeEmpresa}}</div>
            </b-navbar-brand>
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item href="#/diploma">Diplomas</b-nav-item>
                    <!-- <b-nav-item href="#/sobre" >Sobre</b-nav-item> -->
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>

<script>

import axios from 'axios'

export default {
  name: 'NavBar',
  data () {
    return {
      logoUrl: null
    }
  },
  props: {
    nomeEmpresa: String
  },
  mounted () {
    axios.post(process.env.ROOT_API.concat('instituicao'), {})
      .then(response => {
        if (response.data[0].LOGOMARCA) {
          let logomarca = response.data[0].LOGOMARCA
          this.logoUrl = 'data:image/bmp;base64,' + btoa(logomarca)
        }
      }).catch(error => {
        console.log(error)
        this.makeToast('danger', 'Problemas ao conectar com o servidor.', 'Atenção')
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NavBar.vue